export const configureRollbar = (admin: unknown) => {
  // @ts-ignore
  Rollbar.configure({
    payload: {
      admin,
      environment: process.env.NODE_ENV,
    },
  });
};
